import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const DIVIDER_WIDTH = 1

export const IconWrapper = styled.div``

export const formButtonFocusBorderStyles = `
  border-color: ${cssTheme.colors.input.focus.border} !important;
  box-shadow: 0px 0px 0px 1px ${cssTheme.colors.input.focus.border} !important;
`

export const formButtonFocusIconStyles = `
  color: ${cssTheme.colors.input.focus.icon} !important;
`
